import React, { useState } from 'react'
import ChatBubbleIcon from '@material-ui/icons/ChatBubble'
import { checkIsProductionApp } from 'Modules/handleEnvironment'
import { Box, Fab, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { useStyles } from './styles'

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function ChatBot() {
  const classes = useStyles()
  const [chatbotOpen, setChatbotOpen] = useState<boolean>(false)
  const [chatbotCloseIcon, setChatbotCloseIcon] = useState<boolean>(false)

  const openChatbot = () => {
    setChatbotOpen(!chatbotOpen)
    setChatbotCloseIcon(!chatbotCloseIcon)
  }
  return (
    <>
      {!checkIsProductionApp() && (
        <Box className={classes.chatbotContainer}>
          <Fab className={classes.fab} onClick={openChatbot}>
            {!chatbotCloseIcon ? <ChatBubbleIcon /> : <CloseIcon />}
          </Fab>
          {chatbotOpen && (
            <Typography className={classes.chatbotContent}>
              Resilia chatbox
            </Typography>
          )}
        </Box>
      )}
    </>
  )
}
